import { render, staticRenderFns } from "./Parcela.vue?vue&type=template&id=3b88f304&scoped=true&"
import script from "./Parcela.vue?vue&type=script&lang=js&"
export * from "./Parcela.vue?vue&type=script&lang=js&"
import style1 from "./Parcela.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88f304",
  null
  
)

export default component.exports